import React, { useState, useEffect, useCallback } from 'react';
import DataTable from '../Components/DataTable/DataTable';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Controllers from '../Api/Controllers';
import { FormCustom, Input } from '../Components/Form/Form';
import Helpers from '../Helpers/Helpers';
import { toast as toastr } from 'react-toastify';
import { useSelector } from 'react-redux'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

const SubProductsForm = ({ data, onSubmit, idSubProducts, viewDisabled }) => {
  const {
    id = '',
    description = '',
    description_short = '',
    budget = '',
    program = ''
  } = data

  const [row, setRow] = useState({
    id,
    description,
    description_short,
    budget,
    program
  })

  const dataSumbit = useCallback(() => {
    return {
      p_id: row.id,
      p_description: row.description,
      p_description_short: row.description_short,
      p_id_sub_products_master: idSubProducts,
      p_budget: row.budget,
      p_program: row.program
    }
  }, [row, idSubProducts])

  return <FormCustom dataSubmit={dataSumbit()} onSubmit={onSubmit} viewSubmit={!viewDisabled}>
    <Input
      text="ID"
      placeholder="ID"
      classNameParent="col-12 mb-2"
      icon="fa fa-code"
      required
      defaultValue={id}
      onChange={e => setRow({ ...row, id: e.currentTarget.value })}
      disabled={id !== ''}
      pattern="[0-9A-Z-a-z-]{1,20}"
      invalid="Formato incorrecto: Ej: 1-1-1"
      maxLength={20}
    />
    <Input
      text="Descripción"
      placeholder="Descripción"
      classNameParent="col-12 mb-2"
      icon="far fa-comment-alt"
      required
      defaultValue={description}
      onChange={e => setRow({ ...row, description: e.currentTarget.value })}
      disabled={viewDisabled}
    />
    <Input
      text="Descripción Corta"
      placeholder="Descripción Corta"
      classNameParent="col-12 mb-2"
      icon="far fa-comment-alt"
      required
      defaultValue={description_short}
      onChange={e => setRow({ ...row, description_short: e.currentTarget.value })}
      disabled={viewDisabled}
    />
    <Input
      text="Programa"
      placeholder="Programa"
      classNameParent="col-12 mb-2"
      icon="far fa-comment-alt"
      required
      defaultValue={program}
      onChange={e => setRow({ ...row, program: e.currentTarget.value })}
      disabled={viewDisabled}
    />
  </FormCustom>
}

const SubProducts = ({ idSubProducts }) => {
  const nameModulo = 'Subproductos'
  const namePage = 'Subproducto'
  const nameController = 'sub_products'
  const permissions = useSelector(store => store.session.permissions)
  const actionsModule = Helpers.getActions({ permissions, name: 'subproductos' })

  const thead = [
    { name: 'ID', align: 'center' },
    { name: 'Descripción' },
    { name: 'Programa' },
    { name: 'Acc.', align: 'center' }
  ];

  const [rows, setRows] = useState([]);
  const [isProcessing, setIsProcessing] = useState(true);
  const [modalSize, setModalSize] = useState('');
  const [modalShow, setModalShow] = useState(false);
  const [modalHeader, setModalHeader] = useState('');
  const [modalTitle, setModalTitle] = useState('');
  const [form, setForm] = useState('');
  const [reload, setReload] = useState(true);

  useEffect(() => {
    if (reload) {
      Controllers[nameController]['get_' + nameController]({
        p_id: idSubProducts
      }).then(res => {
        setRows(res.data)
      })
        .finally(() => {
          setIsProcessing(false)
          setReload(false);
        });
    }
  }, [reload, idSubProducts])

  const handleUpdate = e => {
    const { id = '', disabled = 0 } = e.currentTarget.dataset;
    let button = e.currentTarget
    let buttonHTML = button.innerHTML;
    button.innerHTML = Helpers.icon.spin()

    setModalTitle(parseInt(disabled) === 1 ? <><i className={'mr-2 ' + actionsModule.view.icon}></i>{actionsModule.view.description} {namePage}</> : (id ? <><i className={'mr-2 ' + actionsModule.update.icon}></i>{actionsModule.update.description} {namePage}</> : <><i className={'mr-2 ' + actionsModule.create.icon}></i>{actionsModule.create.description} {namePage}</>))
    setModalSize('');
    setModalHeader('');

    Controllers[nameController]['get_' + nameController + '_id']({ p_id: id }).then(res => {
      setForm(<SubProductsForm data={res.data} onSubmit={onSubmit} idSubProducts={idSubProducts} viewDisabled={parseInt(disabled) === 1} />);
      setModalShow(true);
    }).catch(req => {
      Helpers.promise.catch({ req, toastr });
      setModalShow(false);
    }).finally(() => button.innerHTML = buttonHTML)
  }

  const onSubmit = ({ e, dataSubmit }) => {
    let $this = e.currentTarget

    let propsValidateForm = { form: $this, toastr };
    if (!$this.checkValidity()) {
      $this.classList.add('was-validated');
      Helpers.form.isFormCorrect(propsValidateForm);
      return;
    } else {
      $this.classList.remove('was-validated');
      if (!Helpers.form.isFormCorrect(propsValidateForm)) {
        return;
      }
    }

    let button = $this.querySelector('button[type=submit]');
    let buttonHTML = button.innerHTML
    button.innerHTML = Helpers.icon.spin();

    Controllers[nameController][nameController + '_insert_update'](dataSubmit).then(res => {
      Helpers.toastr.construct({ response: res.response, message: res.message, toastr });
      if (res.response === 'success') {
        setModalShow(false);
      }
    }).catch(req => {
      Helpers.promise.catch({ req, toastr });
    }).finally(() => {
      button.innerHTML = buttonHTML;
      setReload(true)
    });
  }

  const onDelete = e => {
    const { id = '' } = e.currentTarget.dataset;
    setModalTitle(<><i className="fa fa-trash mr-2"></i> Eliminar {namePage}</>);
    setModalHeader('bg-danger');
    setModalSize('sm');
    setForm(<div className="d-flex flex-column align-items-center">
      <p><strong>¿Eliminar {namePage} #{id}?</strong></p>

      <div>
        <Button variant="danger" size="sm" onClick={e => {
          let button = e.currentTarget
          let buttonHTML = button.innerHTML;
          button.innerHTML = Helpers.icon.spin()

          Controllers[nameController][nameController + '_delete']({
            p_id: id
          }).then(res => {
            Helpers.toastr.construct({ response: res.response, message: res.message, toastr });
          }).catch(req => {
            Helpers.promise.catch({ req, toastr });
          }).finally(() => {
            button.innerHTML = buttonHTML;
            setReload(true)
            setModalShow(false);
          });
        }}>
          <i className="fa fa-check mr-2"></i>Si
        </Button>
        <Button variant="dark" className="ml-2" size="sm" onClick={() => setModalShow(false)}>
          <i className="fa fa-times mr-2"></i>No
        </Button>
      </div>
    </div>);
    setModalShow(true)
  }

  return <>
    <Card>
      <Card.Header className="justify-content-between">
        <span>Listado De {nameModulo}</span>
        {actionsModule.create ? <Button onClick={handleUpdate} variant={actionsModule.create.color} size="sm"><i className={actionsModule.create.icon}></i><span className="ml-2 d-none d-md-inline-block">{actionsModule.create.description} {namePage}</span></Button> : ''}
      </Card.Header>
      <Card.Body>
        <DataTable
          isProcessing={isProcessing}
          tbody={rows}
          thead={thead}
          render={tbody => tbody.map(r => {
            let rowRender = [];
            let i = 0;
            for (let key in r) {
              rowRender.push(<td align={thead[i].align ? thead[i].align : ''}>{r[key]}</td>);
              i++;
            }

            rowRender.push(<td align={thead[i].align ? thead[i].align : ''}>
              {actionsModule.view ? <OverlayTrigger
                placement="top"
                overlay={props => <Tooltip {...props}>
                  {actionsModule.view.description}
                </Tooltip>}
              >
                <Button variant={actionsModule.view.color} data-disabled={1} size="xs" className="mr-1" data-id={r.id} onClick={handleUpdate}>
                  <i className={actionsModule.view.icon}></i>
                </Button>
              </OverlayTrigger> : ''}
              {actionsModule.update ? <OverlayTrigger
                placement="top"
                overlay={props => <Tooltip {...props}>
                  {actionsModule.update.description}
                </Tooltip>}
              >
                <Button variant={actionsModule.update.color} size="xs" className="mr-1" data-id={r.id} onClick={handleUpdate}>
                  <i className={actionsModule.update.icon}></i>
                </Button>
              </OverlayTrigger> : ''}
              {actionsModule.delete ? <OverlayTrigger
                placement="top"
                overlay={props => <Tooltip {...props}>
                  {actionsModule.delete.description}
                </Tooltip>}
              >
                <Button variant={actionsModule.delete.color} size="xs" data-id={r.id} onClick={onDelete}>
                  <i className={actionsModule.delete.icon}></i>
                </Button>
              </OverlayTrigger> : ''}
            </td>);
            return (<tr>
              {React.Children.toArray(rowRender)}
            </tr>);
          })}
        />
      </Card.Body>
    </Card>
    <Modal show={modalShow} onHide={() => setModalShow(false)} size={modalSize} backdrop="static">
      <Modal.Header closeButton className={modalHeader}>
        <Modal.Title as="div">{modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {form}
      </Modal.Body>
    </Modal>
  </>
}

export default SubProducts;